// Reset interactions
export default function resetInteractions() {
  IVP.log(`Resetting interactions`, 'info');
  SL.set('vtInteraction', -1);
  SL.set('vtInteractionOut', -1);
}
